import { MINUS_SIGN_ISSUE } from '../config';
import { CustomErrors } from '../types';

export const validateMinusSign = (
  newValue: string,
  name: string,
  customErrors: CustomErrors,
  setCustomErrors: React.Dispatch<React.SetStateAction<CustomErrors>>,
  clearCustomErrors: (name: string, specificErrorValue: string, clearEntireKey?: boolean) => void
) => {
  if (newValue.length === 1 && newValue === '-') {
    let messagesNew: string[] = [];
    const messages = customErrors[name]?.message;
    if (messages && !messages.includes(MINUS_SIGN_ISSUE)) {
      messages.push(MINUS_SIGN_ISSUE);
    } else if (!messagesNew.includes(MINUS_SIGN_ISSUE)) {
      messagesNew.push(MINUS_SIGN_ISSUE);
    }

    setCustomErrors((prevValue) => ({
      ...prevValue,
      [name]: { message: messages ?? messagesNew },
    }));
  } else if (newValue.length > 1 || newValue !== '-') {
    clearCustomErrors(name, MINUS_SIGN_ISSUE);
  }
};
